import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useCart } from '../../contexts/CartContext';
import { Menu, X, ShoppingBag } from 'lucide-react';

const navLinks = [
  { label: 'Shop', href: '/shop' },
  // { label: 'Collections', href: '/#collections' },
  { label: 'About', href: '/about' },
  { label: 'Contact', href: '/contact' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const { count, setOpen: openCart } = useCart();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setMobileOpen(false); }, [location]);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'backdrop-blur-xl bg-[#F6F3EE]/92 border-b border-[#DDD7CE]/40 shadow-[0_1px_12px_rgba(0,0,0,0.03)]'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-20">
          <Link to="/" data-testid="header-logo" className="font-['Cormorant_Garamond'] text-2xl md:text-3xl font-light tracking-[0.3em] text-[#1E1C1A] hover:text-[#C6A978] transition-colors duration-300">
            KIRAQ
          </Link>

          <nav className="hidden md:flex items-center gap-10" data-testid="desktop-nav">
            {navLinks.map(link => (
              <Link
                key={link.label}
                to={link.href}
                data-testid={`nav-${link.label.toLowerCase()}`}
                className="text-xs font-medium uppercase tracking-[0.2em] text-[#7A7369] hover:text-[#1E1C1A] transition-colors duration-300"
              >
                {link.label}
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <button
              onClick={() => openCart(true)}
              aria-label="Shopping bag"
              className="relative p-2 text-[#1E1C1A] hover:text-[#C6A978] transition-colors"
            >
              <ShoppingBag size={20} />

              {count > 0 && (
                <span className="absolute top-0.5 right-0.5 bg-[#C6A978] text-white text-[9px] w-4 h-4 rounded-full flex items-center justify-center font-semibold leading-none">
                  {count > 9 ? '9+' : count}
                </span>
              )}
            </button>

            <button
              data-testid="mobile-menu-toggle"
              className="md:hidden p-2 text-[#1E1C1A]"
              onClick={() => setMobileOpen(!mobileOpen)}
            >
              {mobileOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {mobileOpen && (
        <div data-testid="mobile-menu" className="md:hidden bg-[#F6F3EE]/95 backdrop-blur-xl border-t border-[#DDD7CE]/40 animate-slide-down">
          <nav className="flex flex-col px-6 py-8 gap-6">
            {navLinks.map(link => (
              <Link
                key={link.label}
                to={link.href}
                className="text-sm font-medium uppercase tracking-[0.2em] text-[#7A7369] hover:text-[#1E1C1A] transition-colors"
              >
                {link.label}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}
